module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/media/02-03.8cdc31d6.mp3";